export const EMAIL_MASS_MAILING_TASK_STATUS_INTERVAL = 2000
